module.exports = __webpack_public_path__ + "1388629a804a14fd48bfb4a9ae3e0074.png";